module.exports = __webpack_public_path__ + "img/xpu-ha-room-2.77fc34ce.jpg";